import { Chip } from '@material-ui/core';
import { useSession } from '../contexts/session';

const SelectedExperienceChip = () => {
  const { selectedExperience } = useSession();
  if (!selectedExperience?.label) return null;
  return (
    <Chip
      data-testid="setup-step-experience-label-chip"
      label={selectedExperience.label}
      variant="filled"
      sx={{
        backgroundColor: '#6a6f7a',
        color: '#fff',
        fontWeight: 700,
      }}
    />
  );
};

export default SelectedExperienceChip;
